export default __webpack_public_path__ + "static/media/welcome-bg11.963a1ba4.png";